import {VoidFunc} from "types/types";
import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";

interface IRadioQuestionOption_Props {
  index: number;
  selectedIndex: number;
  onQuestionAnswered: (index: number, callback: VoidFunc) => void;
  onClearAnswerFeedback: ()=>void;
  answerLocked:boolean;
  correctAnswerIsSelected:boolean;
}

@observer
export class RadioQuestionOption extends React.Component<IRadioQuestionOption_Props> {
  @observable hover: boolean = false;
  @observable wrong: boolean = false;

  handleClick = () => {
    if(!this.props.answerLocked) {
      this.handleStartHover();
      this.props.onQuestionAnswered(this.props.index, this.wrongAnswerCallback);
    }
  }

  handleStartHover = () => {
    if(!this.props.answerLocked && !this.props.correctAnswerIsSelected) {
      this.hover = true;
    }
  }

  handleEndHover = () => {
    this.hover = false;
  }

  wrongAnswerCallback = () => {
    this.wrong = true;
    setTimeout(this.clearWrongAnswer, 1000);
  }

  clearWrongAnswer = () => {
    this.wrong = false;
    this.props.onClearAnswerFeedback();
  }

  render() {

    let error = "";
    let questionStyle: any = {};
    let circleStyle: any = {};

    if(this.props.correctAnswerIsSelected) {
      if(this.props.index === this.props.selectedIndex) {
        circleStyle = {background: "#7ED321"};
      } else if(this.props.answerLocked) {
        circleStyle = {borderColor: "#999999"};
      }
    } else {

      if (this.wrong) {
        error = "Try again";
        circleStyle.borderColor = "red";
        circleStyle.backgroundColor = "red";
        questionStyle.color = "#fafafa";
      } else {
        if (this.hover) {
          circleStyle = {background: "#7ED321"};
        }
      }
    }

    return (
      <div className="option">
				<span
          role="radio"
          style={{position: "relative"}}
          onClick={this.handleClick}
          onTouchStart={this.handleStartHover}
          onTouchMove={this.handleEndHover}
          onMouseEnter={this.handleStartHover}
          onMouseLeave={this.handleEndHover}
        >
					<div className="error">{error}</div>
					<div className="circle" style={circleStyle}></div>
					<div className="question" style={questionStyle}>{this.props.children}</div>
				</span>
      </div>
    )
  }
}


